import React from 'react'
import { ThemeProvider } from 'theme-ui'
import reducer from './redux/reducer'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'

import { HelmetProvider } from 'react-helmet-async'

import { composeWithDevTools } from 'redux-devtools-extension'

import { theme } from './styles/theme'

import PreAwardsPage from './pages/preAwards'
import PostAwardsPage from './pages/postAwards'

export default ({ isServer, initialState, helmetContext = {} }) => {
  const state = isServer ? initialState : window.__initialState__

  const store = createStore(
    reducer,
    state,
    composeWithDevTools(applyMiddleware(thunk))
  )

  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider context={helmetContext}>
        <Provider store={store}>
          <PostAwardsPage />
          {/* <PreAwardsPage /> */}
        </Provider>
      </HelmetProvider>
    </ThemeProvider>
  )
}
